import { IIconProps } from '#components/icons/types';

const ChevronRight = ({ size = 48, color = '#fff' }: IIconProps) => (
  <svg
    className="svg-icon"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    fill={color}
  >
    <path d="M0 0h24v24H0V0z" fill="none" stroke="none" />
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" />
  </svg>
);

export default ChevronRight;
